import React from 'react';

import { styled } from '@mui/material/styles';
import { Button } from '../components/Button';

type Props = {
  className?: string;
};

const Welcome = styled(({ className }: Props) => (
  <div className={className}>
    <h1>
      Locally Owned
      <br />
      Ready-Mix Concrete
      <br />
      Serving Horry County
    </h1>
    <Button href='#contact' variant='full'>
      Contact Us
    </Button>
    <Button href='#products' variant='outline'>
      Show me more.
    </Button>
  </div>
)) <Props>`
  position: absolute;
  width: 1140px;
  top: max(50%, 260px);
  left: 50%;
  transform: translate(-50%, -50%);

  /* Big tablet and beyond 1024px to 1200px */
  @media only screen and (max-width: 1200px) {
    width: 100%;
    padding: 0 2%;

    .row {
      padding: 0 2%;
    }
  }

  /* Small phones to small tablet 481px to 767px */
  @media only screen and (max-width: 767px) {
    padding: 0 4%;
  }
`;

export default Welcome;
